import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;
export const reportService = { getAll, show, store, update, updateStatus, softDelete, getOptions };

export function getAll(filter = {}) {
    const params = { page: filter.pageNumber, size: filter.pageSize };
    if (filter.userName) params.user_name = filter.userName;
    ['type', 'status', 'platformType'].forEach(key => {
        const value = filter[key];
        if (value !== undefined && value !== null && value !== '' && value !== -1) {
            params[key === 'platformType' ? 'platform_type' : key] = value;
        }
    });
    if (filter.sortBy) params.sortBy = filter.sortBy;
    if (filter.orderBy) params.orderBy = filter.orderBy;
    return apiHelper(API_URL).get('/reports', { params });
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/reports/${uuid}`);
}

export function toPayload(data) {
    return { user_uuid: data.userUUID, type: data.type, description: data.description, platform_type: data.platformType };
}

export function store(data) {
    return apiHelper(API_URL).post('/reports', toPayload(data));
}

export function update(data) {
    return apiHelper(API_URL).put(`/reports/${data.uuid}`, toPayload(data));
}

export function updateStatus(data) {
    return apiHelper(API_URL).patch(`/reports/${data.uuid}/status`, { status: data.status });
}

export function softDelete(data) {
    return apiHelper(API_URL).patch(`/reports/delete/${data.uuid}`);
}

export async function getOptions() {
    const response = await apiHelper(API_URL).get('/lookup/users');
    if (!response) throw new Error('Unable to load users.');
    return { users: response.data || [] };
}
